import styled from 'styled-components'

export const Recipes = styled.section`
  display: flex;
`
